import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class QuoteAttachmentResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  list(params) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  upload(file, itemId) {
    const { name, type } = file;
    const urlParams = objectToUrlParams({ name, content_type: type, item: itemId });
    return super
      .post({}, { url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  download(file) {
    return super
      .get({ url: `${this.url}/${file}/download`, responseType: 'blob' })
      .then((response) => response)
      .catch((error) => error.response);
  }

  remove(file) {
    return super
      .delete({ url: `${this.url}/${file}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
